import { render } from "./Tab3View.vue?vue&type=template&id=786899b6&scoped=true"
import script from "./Tab3View.vue?vue&type=script&lang=js"
export * from "./Tab3View.vue?vue&type=script&lang=js"

import "./Tab3View.vue?vue&type=style&index=0&id=786899b6&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786899b6"]])

export default __exports__